import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { JobPointeSettingsService } from 'src/app/service/job-pointe-settings/job-pointe-settings.service';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { JobPointeTransferService } from '../job-pointe-transfer/job-pointe-transfer.service';
import { JobBoardService } from './service/job-board.service';
import { DialogService } from 'src/app/service/dialog/dialog.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { Subscription } from 'rxjs';
import { JobPointePermissionsService } from 'src/app/service/auth/job-pointe-permission.service';
import { PermissionsService } from 'src/app/service/auth/permissions.service';
@Component({
  selector: 'app-job-board',
  templateUrl: './job-board.component.html',
  styleUrls: ['./job-board.component.scss'],
})
export class JobBoardComponent implements OnInit {
  constructor(
    private jobPointeService: JobPointeService,
    private loaderService: LoaderService,
    private jobPointeTransferService: JobPointeTransferService,
    private jobBoardService: JobBoardService,
    private jobPointeSettingsService: JobPointeSettingsService,
    private dialogService: DialogService,
    private toastService: ToastService,
    private window: Window,
    private elementRef: ElementRef,
    private jobPointePermissionsService: JobPointePermissionsService,
    private permissionsService: PermissionsService,
  ) { }

  public tabScrollStates: { [key: string]: number } = {
    board: 0,
    filter: 0,
    format: 0
  };
  public activeTab: string = 'board';
  @ViewChild('container', { static: false }) containerRef!: ElementRef<HTMLDivElement>;

  requestParams: any = {};
  jobBoardSchedule: any;
  jobBoardLocked: boolean = false;
  loading: boolean = true;
  jobBoardCardData: any;
  jobCount: number = 0;
  activeEmployeeCount: number = 0;
  dialogAction: string = '';
  facilitiesList: Array<any> = [];
  jobsList: Array<any> = [];
  selectedFacilityJob: any;
  selectedEmployees: Array<any> = [];
  jobBoardDialogActionSubscription: Subscription;
  selectedEmployeeSubscription: Subscription;
  facilityJobAssignmentSelectedSubscription: Subscription;
  selectedEmployeeCardsSubscription: Subscription;

  objectKeys = data => (data ? Object.keys(data).sort() : []);

  async ngOnInit(): Promise<void> {
    this.requestParams = (await this.jobBoardService.getLocalBoardFilterState()) || {};
    this.getCurrentJobBoardSchedule();
    this.jobBoardCardData = await this.jobBoardService.getLocalCardData();
    if (this.jobBoardCardData) {
      this.getDepartmentJobCardData(false);
    } else {
      this.getDepartmentJobCardData();
    }
    this.jobBoardService.updateJobBoard = this.getDepartmentJobCardData.bind(this);
    this.jobBoardDialogActionSubscription = this.jobBoardService.jobBoardDialogActionSource.subscribe(res => {
      if (res) this.dialogAction = res;
    });

    this.selectedEmployeeSubscription = this.jobBoardService.employeeCardSelectedSource.subscribe(res => {
      if (res && !this.selectedEmployees.find(e => e.id === res.id && e.jobCard.id === res.jobCard.id)) {
        this.selectedEmployees.push(res);
        this.jobBoardService.selectedEmployeeCards.next(this.selectedEmployees);
      } else {
        this.selectedEmployees = this.selectedEmployees.filter(e => e.id !== res.id || e.jobCard.id !== res.jobCard.id);
        this.jobBoardService.selectedEmployeeCards.next(this.selectedEmployees);
      }
    });
    this.facilityJobAssignmentSelectedSubscription = this.jobBoardService.facilityJobAssignmentSelectedSource.subscribe(
      res => {
        this.selectedFacilityJob = res;
      },
    );

    this.selectedEmployeeCardsSubscription = this.jobBoardService.selectedEmployeeCardsSource.subscribe(res => {
      this.selectedEmployees = res;
    });
  }

  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#e3e3e3';
  }

  ngOnDestroy(): void {
    this.jobPointeTransferService.addEmployeeModalIsOpenSource.next(false);
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#fff';
    this.jobBoardDialogActionSubscription.unsubscribe();
    this.selectedEmployeeSubscription.unsubscribe();
    this.selectedEmployeeCardsSubscription.unsubscribe();
    this.facilityJobAssignmentSelectedSubscription.unsubscribe();
    this.clearSelectedEmployees();
  }

  onTabChange(newTab: string) {
    if (!this.containerRef) {
      console.warn('containerRef is not defined yet');
      return;
    }

    let savedScrollPosition = 0;

    this.activeTab = newTab;

    this.tabScrollStates[this.activeTab] = window.scrollY || 0;
    savedScrollPosition = this.tabScrollStates[newTab] || 0;


    setTimeout(() => {
      window.scrollTo(0, savedScrollPosition);
    }, 0);
  }

  getCurrentJobBoardSchedule() {
    this.jobPointeService.read['jobBoardSchedule']({}).subscribe(res => {
      this.jobBoardSchedule = res.data;
      this.jobBoardLocked = this.jobBoardSchedule.status;
      this.jobBoardService.jobBoardLocked.next(this.jobBoardSchedule.status);
    });
  }

  async removeBatchEmployees() {
    for (const employee of this.selectedEmployees) {
      const { jobCard: job } = employee;
      const removeSchedule = {
        userId: employee.id,
        ...(job.jobNumber && { jobId: job.id }),
        ...(job.facilityName && { facilityId: job.id }),
      };
      try {
        const result = await this.jobBoardService.removeEmployeeSchedule(removeSchedule);

        if (!result?.success) continue

        this.toastService.showToast(result.message, 'success');

        const hasEmployeeSidebarOpen = this.selectedEmployees?.find(card => card?.id === employee?.id)

        if (hasEmployeeSidebarOpen) {
          this.jobBoardService.employeeSideBarOpen.next(null);
        }

      } catch (error) {
        this.toastService.showToast('An error ocurred removing an employee', 'error');
      }
    }

    this.jobBoardService.updateJobBoard(false);
    this.clearSelectedEmployees();
  }

  async reassignBatchEmployees() {
    this.jobBoardService.jobBoardDialogAction.next('Move');
    this.dialogService.open('facility-selection-dialog').then(async response => {
      if (response) {
        for (const employee of this.selectedEmployees) {
          const { jobCard: job } = employee;
          try {
            let targetCard = this.selectedFacilityJob?.isSeparateOnJobBoard
              ? this.selectedFacilityJob
              : this.selectedFacilityJob?.facility;
            let result = await this.jobPointeTransferService.moveEmployeeToCard(employee, job, targetCard, false);
            if (result.success) {
              this.toastService.showToast(
                `${employee.employeeAlias || `${employee.firstName} ${employee.lastName}`} successfully moved to ${targetCard?.facilityName || `${targetCard.jobNumber} - ${targetCard?.name}`
                }`,
                'success',
              );
            } else {
              this.toastService.showToast(result.message, 'error');
            }
          } catch (error) {
            this.toastService.showToast(error.message, 'error');
          }
        }
        this.jobBoardService.updateJobBoard(false);
        this.clearSelectedEmployees();
      }
      this.jobBoardService.facilityJobAssignmentSelected.next(null);
    });
  }

  async assignBatchEmployees() {
    this.jobBoardService.jobBoardDialogAction.next('Copy');
    this.dialogService.open('facility-selection-dialog').then(async response => {
      if (response) {
        for (const employee of this.selectedEmployees) {
          try {
            let targetCard = this.selectedFacilityJob?.isSeparateOnJobBoard
              ? this.selectedFacilityJob
              : this.selectedFacilityJob?.facility;
            let result = await this.jobPointeTransferService.addEmployeeToCard(employee, targetCard, false, false);
            if (result.success) {
              this.toastService.showToast(
                `${employee.employeeAlias || `${employee.firstName} ${employee.lastName}`} successfully copied to ${targetCard?.facilityName || `${targetCard.jobNumber} - ${targetCard?.name}`
                }`,
                'success',
              );
            } else {
              this.toastService.showToast(result.message, 'error');
            }
          } catch (error) {
            this.toastService.showToast(error.message, 'error');
          }
        }
        this.jobBoardService.updateJobBoard(false);
        this.clearSelectedEmployees();
      }
      this.jobBoardService.facilityJobAssignmentSelected.next(null);
    });
  }

  printPreview() {
    this.window.print();
  }

  clearSelectedEmployees() {
    this.jobBoardService.selectedEmployeeCards.next([]);
    this.jobBoardService.employeeCardSelected.next(null);
  }

  toggleJobBoardLock() {
    this.dialogAction = this.jobBoardLocked ? 'Unlock' : 'Lock';
    this.dialogService.open('board-lock-dialog').then(async response => {
      if (response) {
        try {
          let result = await this.jobBoardService.toggleJobBoardLock();
          this.jobBoardLocked = !this.jobBoardLocked;
          this.jobBoardService.jobBoardLocked.next(this.jobBoardLocked);
          this.toastService.showToast(result.message, 'success');
        } catch (error) {
          this.toastService.showToast(error.message, 'error');
        }
      }
    });
  }

  getFacilityJobsList() {
    Object.values(this.jobBoardCardData).map(dep => {
      Object.values(dep).map(facility => {
        facility.potentialJobDetail.jobs.map(job => {
          if (!this.jobsList.find(j => j.id === job.id)) {
            job.facility = facility;
            this.jobsList.push(job);
          }
        });
      });
    });
    this.jobsList.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  selectFacilityJob(facilityJob) {
    this.jobBoardService.facilityJobAssignmentSelected.next(facilityJob);
  }

  filterFacilityJobs(query) {
    if (!query) return this.getFacilityJobsList();
    this.jobsList = this.jobsList.filter(job => {
      return (
        job?.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        job?.jobNumber.toLowerCase().indexOf(query.toLowerCase()) > -1
      );
    });
  }

  cleanRequestParams(requestParams) {
    const filterParams = Object.keys(requestParams).reduce((filters, key) => {
      filters[key] = requestParams[key];
      // remove empty scopes
      if ((key.indexOf('scope') >= 0 && (!filters[key] || filters[key] === '')) || !filters[key]) {
        delete filters[key];
      }
      return filters;
    }, {});
    return filterParams;
  }

  async getDepartmentJobCardData(loader = true, requestParams = {}) {
    return new Promise((resolve, reject) => {
      this.loading = true;
      requestParams = { ...this.requestParams, ...requestParams };
      requestParams = this.cleanRequestParams(requestParams);
      loader ? this.loaderService.displayLoader() : null;
      this.jobPointeService.read['departmentJobBoardCards'](requestParams).subscribe(
        res => {
          this.jobBoardCardData = res.data;
          this.jobBoardService.updateLocalCardData(this.jobBoardCardData);
          this.getJobCount();
          this.getActiveEmployeeCount();
          this.getFacilityJobsList();
          this.loaderService.hideLoader();
          this.loading = false;
          resolve(res);
        },
        error => {
          this.loaderService.hideLoader();
          this.loading = false;
          reject(error);
        },
      );
    });
  }

  sortBoardData(sortData) {
    const { sortBy, sortDirection } = sortData;
    (this.requestParams.order = `${sortBy},${sortDirection}`), this.getDepartmentJobCardData(true);
  }
  groupBoardData(groupBy: string) {
    this.requestParams.jobBoardGroupByProperty = groupBy;
    const { jobBoardGroupByProperty } = this.requestParams;
    this.jobBoardService.updateLocalBoardFilterState({
      jobBoardGroupByProperty,
    });
    this.getDepartmentJobCardData(true);
  }

  getJobCount() {
    if (!this.jobBoardCardData) return 0;
    let facilities = [];
    let jobs = [];
    for (let data of Object.values(this.jobBoardCardData)) {
      facilities = facilities.concat(data);
    }
    for (let facility of facilities) {
      jobs = jobs.concat(facility.potentialJobDetail.jobs);
    }
    this.jobCount = jobs.length;
    return this.jobCount;
  }

  filterBoardData(requestParams) {
    if (!Object.keys(requestParams).length) return;
    if (requestParams.search) {
      const { search } = requestParams.search;
      requestParams.search = search.trim();
      requestParams.searchFields = this.searchFields;
    }
    this.requestParams = { ...this.requestParams, ...requestParams };
    this.getDepartmentJobCardData(true);
  }

  clearFilters(filterParams) {
    if (!Object.keys(filterParams).length) return;
    Object.keys(filterParams).forEach(key => {
      this.requestParams[key] = filterParams[key];
    });
    this.getDepartmentJobCardData(true);
  }

  getActiveEmployeeCount() {
    if (!this.jobBoardCardData) return 0;

    const uniqueUserIds = new Set();

    // Iterate over all grouping values (none, department names, project manager names, etc.)
    for (let groupingArray of Object.values(this.jobBoardCardData)) {
      if (!Array.isArray(groupingArray)) continue;

      // Iterate over each job card in this grouping
      groupingArray.forEach(jobCard => {
        // Get employees from the job card's scheduleEmployees
        if (Array.isArray(jobCard.scheduleEmployees)) {
          jobCard.scheduleEmployees.forEach(employee => {
            if (employee.userId) {
              uniqueUserIds.add(employee.userId);
            }
          });
        }

        // Get employees from nested jobs' scheduleEmployees
        if (jobCard?.potentialJobDetail?.jobs) {
          jobCard.potentialJobDetail.jobs.forEach(job => {
            if (Array.isArray(job.scheduleEmployees)) {
              job.scheduleEmployees.forEach(emp => {
                if (emp.userId) {
                  uniqueUserIds.add(emp.userId);
                }
              });
            }
          });
        }
      });
    }

    this.activeEmployeeCount = uniqueUserIds.size;
    return this.activeEmployeeCount;
  }


  modelDetail: any = {};

  settingsData = {
    type: 'jobBoard',
  };

  get searchFields() {
    return [
      'facilityName',
      'owner.owner_name',
      'potentialJobDetail.jobs.job_number',
      'potentialJobDetail.jobs.name',
      'potentialJobDetail.jobs.client_name',
      'potentialJobDetail.jobs.foreman',
      'potentialJobDetail.jobs.project_manager',
      'potentialJobDetail.jobs.scheduleEmployees.employee.first_name',
      'potentialJobDetail.jobs.scheduleEmployees.employee.last_name',
      'potentialJobDetail.jobs.scheduleEmployees.employee.employee_alias',
      'scheduleEmployees.employee.first_name',
      'scheduleEmployees.employee.last_name',
      'scheduleEmployees.employee.employee_alias',
      'scheduleEmployees.employee.city',
      'scheduleEmployees.employee.title',
    ].join(',');
  }

  filters: Array<any> = [
    {
      label: 'Department',
      type: 'select2',
      propertyName: 'scope[department]',
      default: '',
      value: 'id',
      name: 'department_name',
      model: 'departments',
      options: [],
      loadOptions: () => this.loadOptions('departments'),
    },
    {
      label: 'Jobs',
      type: 'autocomplete',
      propertyName: 'scope[job]',
      default: '',
      value: 'id',
      name: 'jobs',
      model: 'jobs',
      options: [],
      loadOptions: () => this.loadOptions('jobs'),
    },
    {
      label: 'Project Manager',
      type: 'select2',
      propertyName: 'scope[projectManager]',
      default: '',
      value: 'employeeAlias',
      name: 'employeeAlias',
      model: 'projectManagers',
      options: [],
      loadOptions: () => this.loadOptions('projectManagers'),
    },
    {
      label: 'Owners',
      type: 'select2',
      propertyName: 'scope[facilityOwners]',
      default: '',
      value: 'id',
      name: 'ownerName',
      model: 'owner',
      options: [],
      loadOptions: () => this.loadOptions('owner'),
    },
    {
      label: 'Facilities',
      type: 'autocomplete',
      propertyName: 'scope[facilities]',
      default: '',
      value: 'id',
      name: 'facilityName',
      model: 'facility',
      options: [],
      loadOptions: () => this.loadOptions('facility'),
    },
    {
      label: 'Certs',
      type: 'autocomplete',
      propertyName: 'scope[jobBoardAttributes]',
      default: '',
      value: 'id',
      name: 'name',
      model: 'jobBoardAttributes',
      options: [],
      loadOptions: () => this.loadOptions('jobBoardAttributes'),
    },
    {
      label: 'Tags',
      type: 'autocomplete',
      propertyName: 'scope[jobBoardTags]',
      default: '',
      value: 'id',
      name: 'label',
      model: 'jobBoardTags',
      options: [],
      loadOptions: () => this.loadOptions('jobBoardTags'),
    },
  ];

  generateExport() {
    this.jobPointeService.export['jobBoard']().subscribe(
      res => {
        this.downloadFile(res.body);
      },
      err => {
        console.error('Error', err);
      },
    );
  }

  downloadFile(blob: any) {
    const a = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = `JobBoard_export.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  loadOptions(key: string): void {
    this.jobPointeSettingsService.read[key]().subscribe(
      res => {
        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});
        this.modelDetail[key] = settings;
        let filter = this.filters.filter(f => f.model === key)[0];
        filter.options = res.data;
      },
      error => {
        console.error(error);
        this.loaderService.hideLoader();
      },
    );
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      job_board_attributes: 'job_board_attributes',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }
}
